module.exports = __webpack_public_path__ + "img/right-red.16e00efa.svg";